import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/system";
import cardData from "../../data/sapfieldglass.json";
import CircularProgress from "@mui/material/CircularProgress";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import Modal from "@mui/material/Modal";
import { useMsal } from "@azure/msal-react";
import axios from "axios";
import {apiURL} from "../../Constant"

const SapFieldglassCards = () => {
  const [modalContent, setModalContent] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const Max_Length = 140;
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const [username, setuserName] = useState(null);
  const [courseData, setCourseData] = useState("");
  const [totalpercent, setTotalPercent] = useState(0);
  let program = "SAPFi";
  const handleOpen = (id) => {
    setOpenModal(true);
    const clickedCourseDetail = cardData.filter((obj) => {
      return obj.id === id;
    });
    setModalContent(clickedCourseDetail[0]);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    if (activeAccount) {
      setuserName(activeAccount.username);
      console.log("username is", activeAccount.username);
    } else {
      setuserName(null);
    }
  }, [activeAccount]);
  useEffect(() => {
    console.log("inside fetch");

    axios
      .get(`${apiURL}/fetchdata/${program}/${username}`, {
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json",
          Pragma: "no-cache",
          Expires: "0",
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setCourseData(res.data);
        console.log("datsis0", res.data);

        // new cards filter
        //   replaceData()
      })
      .catch((err) => {
        console.log(err);
      });
  }, [username]);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const AccordionSummary = styled((props) => (
    <MuiAccordionSummary {...props} />
  ))(({ theme }) => ({
    backgroundColor: "#E4E4E4",
    height: "45px !important",
  }));
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 5,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#A409FF" : "#308fe8",
    },
  }));

  let p = 0;
  let replacedCardSubData;
  if (courseData == "") {
    replacedCardSubData = cardData[0].courses.map((item1) => {
      return { ...item1, percent: 0 };
    });
  } else {
    replacedCardSubData = cardData[0].courses.map((item1) => {
      const item2 = courseData.find(
        (item2) => item2["item title"] == item1.name
      );
      if (item2) {
        p = Number(item2["completion percentage"]) + p;

        return { ...item1, percent: item2["completion percentage"] };
      } else {
        p = Number(item1.percent) + p;

        return item1;
      }
      // return item2?{...item1,percent:item2['completion percentage']}:item1;
    });
  }
  console.log("length is", replacedCardSubData.length, replacedCardSubData);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "20px",
      }}
      id="sapfinancecards"
    >
      <Box className="cardsWrapper">
        <Box className="mb-20">
          <h2>Phases of SAP Fieldglass</h2>
          <p className="learningText">
            <p>
              By providing the essential trainings, we aid in your endeavor to
              develop a prosperous learning journey. Regardless of your level of
              experience, our trainings will provide you the knowledge,
              abilities, and confidence you need to be successful in your role.
            </p>
          </p>
        </Box>
        <Grid
          container
          direction={isSmallScreen ? "column" : "row"}
          spacing={2}
        >
          {cardData.map((item, i) => (
            <Grid item xs={3}>
              <Card sx={{ position: "relative" }}>
                <>
                  <CardMedia
                    component="img"
                    height="120"
                    image={item.image}
                    alt="card-image"
                  />
                  <Stack direction="column" spacing={3} sx={{ top: "0px" }}>
                    <div className="infoText-Wrap">
                      <Box sx={{ color: "white", marginTop: "2px" }}>
                        <h5 className="color1" style={{ fontWeight: "600" }}>
                          <span>{item.title}</span>
                        </h5>
                      </Box>
                      <Box className="info-Duration">
                        <Typography
                          sx={{ fontSize: "12px", marginTop: "10px" }}
                        >
                          {item.description.length > Max_Length ? (
                            <div>
                              {`${item.description.substring(
                                0,
                                Max_Length
                              )}...`}
                              <span
                                className="knowmore"
                                onClick={() => handleOpen(item["id"])}
                              >
                                Know More
                              </span>
                            </div>
                          ) : (
                            <div>
                              {item.description}
                              <span
                                className="knowmore"
                                onClick={() => handleOpen(item["id"])}
                              >
                                Know More
                              </span>
                            </div>
                          )}
                        </Typography>
                        <Modal
                          hideBackdrop
                          open={openModal}
                          onClose={handleClose}
                          aria-labelledby="child-modal-title"
                          closeAfterTransition
                          aria-describedby="child-modal-description"
                          className="modal-container"
                        >
                          <Box className="model">
                            <div className="model_heading">
                              <h5 className="paramodel">
                                {modalContent.title}
                              </h5>
                              <span
                                className="close_btn_model"
                                onClick={handleClose}
                                tabIndex={0}
                              >
                                Close
                              </span>
                            </div>
                            <hr />
                            <div className="mainRootWrapper">
                              <div>
                                <h6>Description :</h6>
                                <p>{modalContent["description"]}</p>
                              </div>
                              <div>
                                <h6>
                                  Target Audience :{" "}
                                  <span>{modalContent["target-audience"]}</span>
                                </h6>
                              </div>
                              {/* <div>
                <h6>Pre-requisite :</h6>
                <p
                 dangerouslySetInnerHTML={{ __html: modalContent["pre-requisite"] }}
                ></p>
               </div> */}
                            </div>
                          </Box>
                        </Modal>
                        <Box
                          sx={{ position: "relative", display: "inline-flex" }}
                          className="circleContainer"
                        >
                          <CircularProgress
                            sx={{
                              height: "65px !important",
                              width: "65px !important",
                              zIndex: "1",
                              color: "#6C4AB6",
                            }}
                            variant="determinate"
                            value={p / replacedCardSubData.length}
                          />
                          <Box
                            sx={{
                              top: 0,
                              left: 0,
                              bottom: 0,
                              right: 0,
                              position: "absolute",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: "white",
                              borderRadius: "50%",
                              height: "65px",
                              width: "65px",
                              padding: "2px",
                              border: "1px solid #6C4AB6",
                            }}
                            className="progressAndDuration"
                          >
                            <Typography
                              className="innerBorder1"
                              sx={{
                                fontSize: "0.55rem",
                                color: "#6D398F",
                                textAlign: "center",
                                fontWeight: "600",
                              }}
                              variant="caption"
                              component="div"
                              color="text.secondary"
                            >
                              <span className="completionNum">{`${Math.round(
                                p / replacedCardSubData.length
                              )}%`}</span>{" "}
                              complete
                            </Typography>
                          </Box>
                        </Box>
                        <Box className="durationWrapNew">
                          {item.id === "4" ? (
                            ""
                          ) : (
                            // <img className="weekImage" src={item.duration}></img>
                            // <stack sx={{ position: "absolute" }}><img className="hourGlass" src="images/Selenium/LearningCards/duration-box.png">
                            <stack>
                              <img
                                className="hourGlass"
                                src="images/Hourglass.png"
                              ></img>{" "}
                              <Typography className="hourText">
                                <span className="smallText">Duration</span>{" "}
                                <span className="bottom-color1">
                                  {Math.round(item.hour)} Hours
                                </span>
                              </Typography>
                            </stack>
                          )}
                        </Box>
                      </Box>
                    </div>
                  </Stack>
                </>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Accordion sx={{ width: "100%", background: "#E4E4E4" }}>
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon
                          sx={{
                            fontSize: "1.9rem",
                            border: "solid 1.3px #6D398F",
                            color: "#6D398F",
                          }}
                        />
                      }
                    >
                      <Typography
                        sx={{ color: "#6D398F" }}
                        className="training-type"
                      >
                        Courses
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails
                      sx={{ width: "100%" }}
                      className="mainAccDetails"
                    >
                      {replacedCardSubData.map((course, i) => (
                        <Box
                          sx={{
                            width: "100%",
                            background: "white",
                            px: "15px",
                          }}
                        >
                          <Stack
                            direction="column"
                            mt={1.5}
                            className="acc-stack"
                            sx={{ overflowY: "auto" }}
                          >
                            <Stack
                              direction="row"
                              spacing={2}
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                alignItems: "center",
                              }}
                            >
                              <Stack
                                direction="row"
                                spacing={1}
                                sx={{
                                  flex: "4",
                                  display: "flex",
                                  alignItems: "start",
                                  padding: "5px 10px",
                                }}
                              >
                                <Box>
                                  <img
                                    src="images/SRE/LearningCards/bullet.svg"
                                    className="learning-bullet-icon"
                                  ></img>
                                </Box>
                                <Button
                                  sx={{
                                    fontSize: "12px",
                                    textTransform: "none",
                                    textAlign: "start",
                                    marginLeft: "0px",
                                  }}
                                  color="primary"
                                  target="_blank"
                                  href={course.link}
                                >
                                  {course.name}
                                </Button>
                              </Stack>
                              <Typography
                                sx={{ color: "#A409FF", fontSize: "12px" }}
                              >
                                {course.percent}%
                              </Typography>
                              {/* <BorderLinearProgress sx={{ width: "50px", flex: "1" }}  variant="determinate" value={course.percent} /> */}
                            </Stack>
                          </Stack>
                        </Box>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default SapFieldglassCards;
